import React from "react";
import ConversionView from "../components/ConversionView";
import CurrencyList from "../components/CurrencyList";
import useLatestFXRate from "../hooks/useLatestFXRate";
import { BLUE_5EA0 } from "../styles/Colors";
import Header from "../components/Header";
function HomePage() {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const useRate = useLatestFXRate();

	return (
		<div
			style={{
				marginTop: 90,
				maxWidth: 1200,
				margin: "auto",
				backgroundColor: BLUE_5EA0,
			}}
		>
			<div className="header">
				<Header />
			</div>

			<div className="homepage">
				<CurrencyList />
			</div>

			<div className="homepage-cv">
				<ConversionView />
			</div>
		</div>
	);
}

export default HomePage;
